
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ApiComandiGrid extends Serenity.EntityGrid<ApiComandiRow, any> {
        protected getColumnsKey() { return ApiComandiColumns.columnsKey; }
        protected getDialogType() { return ApiComandiDialog; }
        protected getIdProperty() { return ApiComandiRow.idProperty; }
        protected getInsertPermission() { return ApiComandiRow.insertPermission; }
        protected getLocalTextPrefix() { return ApiComandiRow.localTextPrefix; }
        protected getService() { return ApiComandiService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}